<template>
<div>
    <div v-for="(comment, index) in comments" :key="index">
        <div class="mt-3 border-bottom comment-holder">
            <h5 class="font-weight-bold mb-3">
                <span v-if="!hideAuthor">{{comment.author}} at {{comment.datetime}}</span>
                <span v-if="hideAuthor">Comment posted at {{comment.datetime}}</span>
            </h5>
            <p>{{comment.text}}</p>
            <span
                v-if="isEditable && (loggedUser.role === UserRoles.ADMIN || comment.author === loggedUser.name)"
                class="comment-remove-item tim-icons icon-trash-simple" @click="removeComment(comment, index)"
                >
            </span>
        </div>
    </div>
    <div v-if="newComment">
        <base-input>
            <textarea class="form-control mt-5" placeholder="Comment here" v-model="newComment.text"></textarea>
        </base-input>
        <base-button class="mb-1 pull-right" type="info" size="sm" @click="saveComment">
            {{$t('medium_grant_ev.general__save_comment')}}
        </base-button>
    </div>
    <div class="clearfix"></div>
    <base-button v-if="isEditable" type="simple" @click="addComment" size="sm" class="mt-3 mr-2 btn-fill" v-bind:class="{'pull-right' : pullRight}">
        {{$t('medium_grant_ev.general__add_comment')}}
    </base-button>
</div>
</template>
<script>
import { UserRoles } from '@/services';
import { TimeLine, TimeLineItem, } from 'src/components';

export default {
    name: 'comment-box',
    components: {
        TimeLine,
        TimeLineItem
    },
    props: {
        comments: {
            type: Array,
            default: () => []
        },
        isEditable: {
            type: Boolean,
            default: true
        },
        pullRight: {
            type: Boolean,
            default: true
        },
        hideAuthor: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            UserRoles,
            newComment: undefined,
            loggedUser: {},
        };
    },
    methods: {
        getDateTime() {
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0');
            var yyyy = today.getFullYear();
            var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            today = mm + '.' + dd + '.' + yyyy;
            return today + ' ' + time;
        },
        saveComment() {
            let vm = this;
            if (vm.newComment.text.length > 0) {
                vm.newComment.datetime = vm.getDateTime();
                vm.comments.push(vm.newComment);
            }
            vm.newComment = undefined;
        },
        addComment() {
            let vm = this;
            if (vm.newComment === undefined) {
                vm.newComment = {
                    text: '',
                    author: vm.loggedUser.name
                }
            } else {
                vm.newComment = undefined;
            }
        },
        removeComment(comment, index)
        {
            const vm = this;

            if (vm.isEditable && (vm.loggedUser.role === UserRoles.ADMIN || comment.author === vm.loggedUser.name))
            {
                if (confirm('Are you sure you want to remove this comment?'))
                {
                    vm.comments.splice(index, 1);
                }
            }
        }
    },
    watch: {
        comments: {
            handler: function(val) {
                this.$emit('input', val);
            },
            deep: true
        }
    },
    mounted() {
        let vm = this;
        vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
    },
};
</script>
<style lang="scss" scoped>
.comment-holder
{
    position: relative;
}

.comment-remove-item
{
    position: absolute;
    top: 12px;
    right: 5px;
    cursor: pointer;
    line-height: 4.4rem;
    // visibility: hidden;
    // opacity: 0;
    transition-property: visibility, opacity, color;
    transition-duration: .3s;
    transition-timing-function: ease-in-out;

    &:hover
    {
        color: #f00;
    }
}
</style>
